<div class="sda-container">
  <div class="page-top-banner">
    <div class="title">SDAs</div>

    <div class="action-zone">
      <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Plateforme :</mat-label>
            <mat-select [(ngModel)]="platform" (ngModelChange)="onPlatformChange()">
              <mat-option value="Centrex NG">Centrex NG</mat-option>
              <mat-option value="Centrex Enreach">Centrex Enreach</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
  </div>

  <div class="table-container">
    <form class="filters-form" [formGroup]="filtersForm">
      <div class="mat-elevation-z8 general-table">
        <table mat-table class="default-table" [dataSource]="dataSource" matSort>

          <!-- SDA -->
          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>SDA</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="number" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('number')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.number }}
            </td>
          </ng-container>

          <!-- Target -->
          <ng-container matColumnDef="target">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Extension</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="target" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('target')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.target || '—' }}
            </td>
          </ng-container>

          <!-- TargetType -->
          <ng-container matColumnDef="targetType">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Nature</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="targetType" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('targetType')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.targetType || '—' }}
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <div class="actions-cell">
                <button mat-icon-button (click)="onView(row)">
                  <mat-icon>visibility</mat-icon>
                </button>
                @if (isFullAccess) {
                <button mat-icon-button (click)="onEdit(row)">
                  <mat-icon>edit</mat-icon>
                </button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </form>
  </div>

  <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
</div>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.8)" color="#00D2B4" size="large" type="timer"
    [fullScreen]="false"></ngx-spinner>